export default __webpack_public_path__ + "static/media/smile-solid.5e5ecce8.svg";